import { ValueLabel } from "@features/ax/shared/ValueLabel";
import React from "react";

export const ServiceDetails = ({ consumerData }: any) => {
  console.log("SERVICE consumerData =>", consumerData);
  const consumerServiceData = consumerData?.result || {};
  const SERVICE_DETAILS = {
    serviceInfo: [
      {
        label: "Service Start Date",
        value: consumerServiceData?.registrationDate || "NA",
      },
      {
        label: "Preferred Contact Method",
        value: Array.isArray(consumerServiceData?.preferredContactMethod)
          ? consumerServiceData.preferredContactMethod.join(", ")
          : consumerServiceData?.preferredContactMethod || "NA",
      },

      {
        label: "Utility Services",
        value: Array.isArray(consumerServiceData?.utilityService)
          ? consumerServiceData.utilityService.join(", ")
          : consumerServiceData?.utilityService || "NA",
      },
    ],

    coApplicant: [
      {
        label: "Name",
        value: consumerServiceData?.additionalData?.secondaryConsumer
          ? `${consumerServiceData.additionalData.secondaryConsumer.firstName || ""} ${consumerServiceData.additionalData.secondaryConsumer.lastName || ""}`.trim()
          : "NA",
      },
      {
        label: "Phone",
        value:
          consumerServiceData?.additionalData?.secondaryConsumer
            ?.contactNumber || "NA",
      },
      {
        label: "Email",
        value:
          consumerServiceData?.additionalData?.secondaryConsumer?.email || "NA",
      },
      {
        label: "Relationship to Applicant",
        value:
          consumerServiceData?.additionalData?.secondaryConsumer
            ?.secondaryConsumerDisplay || "NA",
      },
    ],
  };

  const rawServices =
    consumerServiceData?.utilityService ||
    consumerServiceData?.selectServicesHeader ||
    [];
  const servicesArray = Array.isArray(rawServices)
    ? rawServices
    : rawServices
      ? [rawServices]
      : [];

  const ownershipDetails = consumerServiceData?.ownershipDetails || {};
  const structureChoice = ownershipDetails.structureChoice;

  const getAccountTypeLabel = (choice: string) => {
    switch (choice) {
      case "INDIVIDUAL":
        return "Individual Account";
      case "Tenant":
        return "Tenant Account";
      case "Master":
        return "Master account";
      case "Sub_account":
        return "Sub-account";
      default:
        return "NA";
    }
  };

  const accountTypeLabel = getAccountTypeLabel(structureChoice);
  const ownerDetail = ownershipDetails.ownershipDetail || {};

  return (
    <div className="border rounded-2xl p-6 bg-white w-full">
      {/* ---- Title ---- */}
      <h2 className="text-xl font-semibold mb-6">Service Details</h2>

      {/* ---- Service Information ---- */}
      <h3 className="text-sm font-semibold mb-3">Service Information</h3>

      <div className="grid grid-cols-2 gap-y-6 gap-x-10">
        {SERVICE_DETAILS.serviceInfo.map((item, idx) => (
          <ValueLabel key={idx} label={item.label} value={item.value} />
        ))}
      </div>

      <div className="border-t my-6" />
      <h3 className="text-sm font-semibold mb-3">Number of Connections</h3>

      <div className="flex flex-col gap-3">
        {(() => {
          const visibleServices = servicesArray
            .map((service: any) => {
              const srvName =
                typeof service === "object" && service !== null
                  ? service.value || service.label
                  : service;
              const label =
                typeof service === "object" && service !== null
                  ? service.label || service.value
                  : service;
              const quantityMapping =
                consumerServiceData?.additionalData
                  ?.utilityServiceQuantityMapping ||
                consumerServiceData?.additional_data
                  ?.utility_service_quantity_mapping ||
                consumerServiceData?.utility_service ||
                consumerServiceData?.utilityService ||
                consumerServiceData?.number_of_connections ||
                consumerServiceData?.service_quantities ||
                {};
              const count =
                quantityMapping?.[srvName] ??
                quantityMapping?.[label] ??
                consumerServiceData?.[`service_quantity_${srvName}`] ??
                consumerServiceData?.[`service_quantity_${label}`] ??
                0;

              return {
                srvName,
                label: String(label || srvName || ""),
                count: Number(count) || 0,
              };
            })
            .filter((item: any) => item.count > 0);

          if (visibleServices.length === 0) {
            return (
              <p className="text-sm text-muted-foreground italic">
                No utility services selected
              </p>
            );
          }

          return visibleServices.map((item: any, idx: number) => (
            <div
              key={idx}
              className="flex items-center justify-between p-3.5 px-5 rounded-xl border border-gray-200 bg-gray-50"
            >
              <span className="text-sm font-medium text-gray-800">
                {item.label}
              </span>
              <div className="flex items-center gap-1.5">
                <span className="text-base font-bold text-gray-900">
                  {item.count}
                </span>
                <span className="text-xs text-gray-500 font-normal">
                  {item.count === 1 ? "connection" : "connections"}
                </span>
              </div>
            </div>
          ));
        })()}
      </div>

      {/* Divider & Co-Applicant Details */}
      {consumerServiceData?.additionalData?.secondaryConsumer &&
        Object.keys(consumerServiceData.additionalData.secondaryConsumer)
          .length > 0 && (
          <>
            <div className="border-t my-6" />
            <h3 className="text-sm font-semibold mb-3">Co-Applicant Details</h3>

            <div className="grid grid-cols-2 gap-y-6 gap-x-10">
              {SERVICE_DETAILS.coApplicant.map((item, idx) => (
                <ValueLabel key={idx} label={item.label} value={item.value} />
              ))}
            </div>
          </>
        )}

      {/* ---- Account Structure section ---- */}
      <div className="border-t my-6" />
      <h3 className="text-sm font-semibold mb-3">Account Structure</h3>

      <div className="grid grid-cols-2 gap-y-6 gap-x-10">
        <ValueLabel label="Account Type" value={accountTypeLabel} />

        {/* Conditional Owner Details for Tenant Account */}
        {structureChoice === "Tenant" && (
          <>
            <ValueLabel
              label="Owner name"
              value={ownerDetail.ownerName || "NA"}
            />
            <ValueLabel
              label="Owner Phone no"
              value={ownerDetail.ownerPhone || "NA"}
            />
            <ValueLabel
              label="Owner Email"
              value={ownerDetail.ownerEmail || "NA"}
            />
            <ValueLabel
              label="Owner Address"
              value={ownerDetail.ownerAddress || "NA"}
            />
          </>
        )}

        {/* Conditional Master Details for Sub-account */}
        {structureChoice === "Sub_account" && (
          <>
            <ValueLabel
              label="Master account no"
              value={ownershipDetails.masterAccountNo || "NA"}
            />
            <ValueLabel
              label="Master account name"
              value={ownershipDetails.masterAccountName || "NA"}
            />
          </>
        )}
      </div>
    </div>
  );
};
